module.exports = __webpack_public_path__ + "ba3b330027660deb607444b59938cadd.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/aa-5050-white.png
// module id = 822
// module chunks = 0